import React from 'react';
import axios from 'axios';
import {apiURL, obtainURLParam, isLoggedIn, showSpinner, hideSpinner} from "src/utilities/utilityFunctions";
import store from 'src/store';
import {updateAppSettings} from "src/actions/foundationActions";
import {obtainContent} from "src/services/APIServices";
import {blurbs} from "src/datamodels/foundation";
import {updateDataStore} from "src/actions/foundationActions";

export const checkConnection = () => {
    axios.get(apiURL() + "/KimRoot/testConnection").then((evt)=>processTest(evt)).catch((evt)=>failTest(evt));
};

const failTest= ()=> {
    store.dispatch(updateAppSettings({connectionLive:false}));
};

const processTest = (evt) => {
    if (evt.data.statusCode===200) {
        store.dispatch(updateAppSettings({connectionLive:evt.data.data}));
    }
};

let connectionTimer=null;

export const createConnectionTimer = (props) => {
    if(!connectionTimer){checkStatus(props)}
};

const checkStatus = (props) => {
    checkConnection(props);
    clearInterval(connectionTimer);
    connectionTimer = setInterval(()=>{
        checkConnection(props);
    },300000)
};

export const establishAppMod = () => {
    let stateData = store.getState();
    let randLoad =obtainURLParam("randLoad");
    return (
        randLoad
            ? "components/Testing/RandomLoad"
            : stateData.appSettings?.welcomeModName
            ? stateData.appSettings.welcomeModName
            : 'KIM/Welcome'
    );
};

export const cleanNewState = (newState) => {
    let toClean = Object.assign({}, newState);
    delete toClean["dataStore"];
    delete toClean["simplewebrtc"];
    delete toClean["dataStore"];
    if (toClean.simplewebrtc?.api?.signalingClient?.xmpp?.transports?.websocket) {
        delete toClean.simplewebrtc.api.signalingClient.xmpp.transports.websocket;
    }
    return toClean;
};

export const showTestData = (props) => {

    if (props.appSettings.testMode) {
        let newState = Object.assign({}, props.state);


        let output = 'Can not stringify state';
        try {
            output = JSON.stringify(cleanNewState(newState));
        } catch (err) {
            console.dir(err);
        }
        return <div id="testData">{output}</div>
    }
};
/*
export const moduleShow = (props) => {return props.dataStore.appMainModule ? <props.dataStore.appMainModule /> : <span>Welcome</span>;};
*/
export const currMainMod = (props) => {
    return props.appSettings.appMainModuleName
        ? props.appSettings.appMainModuleName
        : isLoggedIn()
            ? props.appSettings.defaultLoggedInModule
            : props.appSettings.defaultModule
};

export const returnHeightOf = (id) => {
    let elem=document.getElementById(id);
    if(elem) {
        var style = elem?.currentStyle || window.getComputedStyle(elem);
        return (style
            ? parseInt(style.height) +
            parseInt(style.marginTop) +
            parseInt(style.marginBottom) +
            parseInt(style.borderTopWidth) +
            parseInt(style.borderBottomWidth) +
            parseInt(style.paddingBottom) +
            parseInt(style.paddingTop)
            : 0);
    }
    return 0;
};

export const returnBoundingRectOf = (id) =>{
    let elem=document.getElementById(id);
    return elem ? elem.getBoundingClientRect() : {};
};

export const returnWidthOf = (id) => {
    return document.getElementById(id)? document.getElementById(id).offsetWidth : 0;
};

export const goHome = () => {
    let comp = isLoggedIn() ? store.getState().appSettings.defaultLoggedInModule : store.getState().appSettings.defaultModule;
    store.dispatch(updateAppSettings({hideTopNav:false,appMainModuleName:comp}));
};

export const preLoadText = () => {
    //eslint-disable-next-line
    blurbs.map((item)=>{
        obtainBlurb(item.slug,item.key);
    });
};

export const obtainBlurb = (slug,key) => {
    showSpinner();
    obtainContent(slug,(evt)=>processContent(key,evt),(evt)=>failContent(key,evt));
};

const processContent = (key,evt)=>{
    hideSpinner();
    store.dispatch(updateDataStore({[key]:evt.data}));
};

const failContent = (key,evt)=>{
    hideSpinner();
    console.dir(evt);
};

export const removeAllChildren = (id) => {
    let parent = document.getElementById(id);
    while (parent.firstChild) {
        parent.removeChild(parent.firstChild);
    }
};
